import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getVolunteerrequest } from "../../store/actions/volunteerrequests_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/volunteerrequests_enum";
import SingleView from "../../components/common/SingleView";
const ViewVolunteerrequest = ({
  getVolunteerrequest,
  match,
  volunteerrequest: { loading, volunteerrequest },
}) => {
  useEffect(() => {
    getVolunteerrequest(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Volunteerrequests"
          mainLinkTitle="Volunteerrequests"
          mainLinkUrl="/volunteerrequests"
          activeLink="View"
        />
        {!loading ? (
          volunteerrequest && (
            <SingleView
              data={volunteerrequest}
              inputFields={inputFields}
              label="Volunteerrequest"
              link="volunteerrequests"
              id={volunteerrequest.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  volunteerrequest: state.volunteerrequest,
});

const mapDispatchToProps = { getVolunteerrequest };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewVolunteerrequest);
